"use client";
import React from 'react';
import { AppProvider } from './context/AppContext';
import { UserProvider } from './context/UserContext';
import { VisualProvider } from './context/VisualContext';
import CosmicMainComponent from './components/core/CosmicMainComponent';

export default function App() {
  return (
    <UserProvider>
      <VisualProvider>
        <AppProvider>
          <CosmicMainComponent />
        </AppProvider>
      </VisualProvider>
    </UserProvider>
  );
}
